import React from 'react'
import { IGame } from '../../../../api/types/game'
import { Link, Paper, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { Link as RouterLink } from 'react-router-dom'
import { DeleteIconButton } from '../../../../components/DeleteIconButton/DeleteIconButton'
import { useInvalidatingMutation } from '../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { mutationDeleteGame } from '../../../../api/mutations'
import { useAuth } from '../../../../context/Auth'
import { gamesQueryKey } from '../../../../api/queries'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3),
      margin: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
    },
    name: {
      paddingLeft: theme.spacing(2),
      fontSize: '1.4em',
    },
    actions: {},
    button: {
      margin: theme.spacing(0.2),
    },
    title: {
      display: 'flex',
      alignItems: 'center',
    },
  })
)

interface GameListEntryProps {
  game: IGame
}

const weapons = [
  'img/weapons/bone_club.png',
  'img/weapons/scapula_axe.png',
  'img/weapons/knife.png',
  'img/weapons/flail.png',
  'img/weapons/nunchaku.png',
  'img/weapons/short_bone_bow.png',
  'img/weapons/battle_axe.png',
  'img/weapons/bone_dagger.png',
  'img/weapons/long_bone_bow.png',
  'img/weapons/rib_ripper.png',
  'img/weapons/scythe.png',
  'img/weapons/rib_bow.png',
  'img/weapons/sling.png',
  'img/weapons/double_rib_bow.png',
]

export const GameListEntry: React.FC<GameListEntryProps> = ({ game }) => {
  const { mutate: handleDeleteGame, isLoading: isMutating } = useInvalidatingMutation<
    AxiosResponse,
    string
  >((slug: string) => mutationDeleteGame(slug), [gamesQueryKey()])
  const classes = useStyles()
  const auth = useAuth()
  return (
    <>
      <Paper className={classes.paper}>
        <div className={classes.title}>
          <img src={weapons[game.id % weapons.length]} alt={'Icon'} />
          <Link
            component={RouterLink}
            className={classes.name}
            to={'/games/' + game.slug}
            underline="hover"
          >
            {game.name}
          </Link>
        </div>
        <div className={classes.actions}>
          {(auth?.gm || auth?.admin) && (
            <DeleteIconButton
              confirmationBody={
                <div>
                  Delete game <span className={'font-weight-bold'}>{game.name}</span>?
                </div>
              }
              isLoading={isMutating}
              onClick={() => handleDeleteGame(game.slug)}
            />
          )}
        </div>
      </Paper>
    </>
  )
}
